import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

export const passportTypeOptions: ISelectOption<string>[] = [
  {
    id: 'isKnm',
    label: 'КНМ',
    value: 'isKnm',
  },
  {
    id: 'isPm',
    label: 'ПМ',
    value: 'isPm',
  },
  {
    id: 'isDecision',
    label: 'Иные решения',
    value: 'isDecision',
  },
];
